import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  JaarrekeningBalans
} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../../../../gedeelde-componenten/gedeelde-componenten.component";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-gebouwen-derden',
  templateUrl: './spec-gebouwen-derden.component.html',
  styleUrls: ['./spec-gebouwen-derden.component.scss'],
  imports: [
    SharedUiButtonModule,
    SharedUiDialogModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class SpecGebouwenDerdenComponent implements OnInit ,OnDestroy{
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private currentAangifte = {} as Aangifte;
    private partnerAangifte = {} as Aangifte;

    public showSpinner = true;

    public gebouwenDerdenFg = {} as FormGroup;
    public dialogVisible = false;

    showDialog() {
        this.dialogVisible = true;
    }

    constructor(
        public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
        private router: Router,
        private fb: FormBuilder) {
        this.gebouwenDerdenFg = this.fb.group<JaarrekeningBalans>({
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            bodemwaarde: null as unknown as number,
            gebruikBinnenEigenOnderneming: false,
            omschrijving: 'Materiele vaste activa - gebouwen en terreinen derden'
        })
    }

    private resetFormGroup() {
        this.gebouwenDerdenFg.setValue({
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
            aanschafWaarde: null as unknown as number,
            restWaarde: null as unknown as number,
            bodemwaarde: null as unknown as number,
            gebruikBinnenEigenOnderneming: false,
            omschrijving: 'Materiele vaste activa - gebouwen en terreinen derden'
        }, {emitEvent: false})
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.partner.subscribe((boolean) => {
                    this.partnerBoolean = boolean;
                    this.resetFormGroup()
                    if (!boolean) {
                        let gebouwenDerden = {} as JaarrekeningBalans
                        if (this.aangifte.box1?.winstUitOnderneming?.ondernemingen[0].materieleVasteActiva?.at(1)) {
                            gebouwenDerden = this.aangifte.box1?.winstUitOnderneming?.ondernemingen[0].materieleVasteActiva?.at(1) as JaarrekeningBalans;
                        }
                        this.gebouwenDerdenFg.patchValue(gebouwenDerden);
                    } else {
                        let gebouwenDerden = {} as JaarrekeningBalans
                        if (this.aangifte.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0].materieleVasteActiva?.at(1)) {
                            gebouwenDerden = this.aangifte.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0].materieleVasteActiva?.at(1) as JaarrekeningBalans;
                        }
                        this.gebouwenDerdenFg.patchValue(gebouwenDerden);
                    }
                })
            }
        })
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter(
            (event: Event): event is NavigationEnd =>
              event instanceof NavigationEnd,
          ),
        )
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.gebouwenDerdenFg.dirty
  }

    saveForm(): void {
        setTimeout(() => {
            this.partner.subscribe((partner) => {
                if (!partner) {
                    const ondernemingen = this.aangifte.box1?.winstUitOnderneming?.ondernemingen;
                    if (ondernemingen && ondernemingen[0]?.materieleVasteActiva && ondernemingen[0].materieleVasteActiva.length >= 3) {
                        ondernemingen[0].materieleVasteActiva[1] = this.gebouwenDerdenFg.value;
                        this.incomeTaxEntity.aangifte = {
                            ...this.aangifte,
                        }
                        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
                    }
                } else {
                    const ondernemingen = this.aangifte.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen;
                    if (ondernemingen && ondernemingen[0]?.materieleVasteActiva && ondernemingen[0].materieleVasteActiva.length >= 3) {
                        ondernemingen[0].materieleVasteActiva[1] = this.gebouwenDerdenFg.value;
                        this.incomeTaxEntity.aangifte = {
                            ...this.aangifte,
                            partnerAangifte: {
                                ...this.aangifte
                            }
                        }
                        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
                    }
                }
            });
        }, 0)
    }
    public heeftOndernemingen(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte &&
                this.aangifte.partnerAangifte &&
                this.aangifte.partnerAangifte.box1 &&
                this.aangifte.partnerAangifte.box1.winstUitOnderneming &&
                this.aangifte.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
                this.aangifte.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        } else {
            return !!(this.aangifte &&
                this.aangifte.box1 &&
                this.aangifte.box1.winstUitOnderneming &&
                this.aangifte.box1.winstUitOnderneming.ondernemingen &&
                this.aangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
        }
    }
}



